<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>Supplier - {{ this.supplierData.supplierId }}</h2>
</div>

<nz-tabset class="mt-5">

  <nz-tab nzTitle="Supplier Information">

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <section id="supplierDetails">

        <nz-card>
          <div class="flex justify-between ">
            <div>
              <h5 class="text-primary">Supplier Details</h5>
            </div>

            <button (click)="editNavigate()" *appHasAnyPrivilege="'SUPPLIER_UPDATE'" nz-button
                    nzType="primary"
                    style="max-width: 120px">Edit Details
            </button>

          </div>
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

            <div>
              <div class="sub-section" style="height: 100%">
                <div class="item-row">
                  <p class="subject-name">Name</p>
                  <p
                    class="subject-data">{{ supplierData.supplierDetails.name ? supplierData.supplierDetails.name : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Mobile Number</p>
                  <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                     href="tel:{{supplierData.supplierDetails.mobileNo}}-{{supplierData.supplierDetails.mobileNo}}">{{ supplierData.supplierDetails.mobileNo ? supplierData.supplierDetails.mobileNo : '-' }}</a>
                  </p>

                </div>
                <div class="item-row">
                  <p class="subject-name">Email</p>
                  <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                     href="mailto:{{supplierData.supplierDetails.email}}">{{ supplierData.supplierDetails.email ? supplierData.supplierDetails.email : '-' }}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </nz-card>
      </section>

      <section id="paymentDetails" class="mt-5">
        <nz-card>
          <div>
            <h5 class="text-primary">Payment Details</h5>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Bank Name</p>
                    <p
                      class="subject-data">{{ supplierData.paymentDetails.bankName ? supplierData.paymentDetails.bankName : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Branch Name</p>
                    <p
                      class="subject-data">{{ supplierData.paymentDetails.branch ? supplierData.paymentDetails.branch : '-' }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Account Type</p>
                    <p
                      class="subject-data">{{ supplierData.paymentDetails.accountType ? supplierData.paymentDetails.accountType : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Account Holders name</p>
                    <p
                      class="subject-data">{{ supplierData.paymentDetails.holderName ? supplierData.paymentDetails.holderName : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Account Number</p>
                    <p
                      class="subject-data">{{ supplierData.paymentDetails.accountNo ? supplierData.paymentDetails.accountNo : '-' }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div>
                    <p class="subject-name">Attachments</p>
                    <div class="flex flex-row gap-2 items-center py-2">
                      <div class="flex flex-col mt-2">
                        <a *ngFor="let file of supplierData.paymentAttachment" href="{{file.url}}"
                           [nz-tooltip]="file.name"
                           target="_blank"><span nz-icon nzType="file" class="text-sm" nzTheme="outline"></span><span
                          class="ml-2 text-sm"> - {{ file.name }}</span></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>


  </nz-tab>

  <nz-tab *appHasAnyPrivilege="'SUPPLIER_DRIVER_VIEW'" nzTitle="Drivers">

    <div class="flex flex-col sm:flex-row space-x-2 mb-8">

      <div class="flex-grow mb-2">
        <div [ngClass]="loading ? 'hidden' : 'block'">
          <nz-collapse>
            <nz-collapse-panel [nzHeader]="'Advanced Search'">
              <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                    <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input
                           placeholder="Search here"/>
                  </nz-input-group>

                  <ng-template #suffixIconSearchButton>
                    <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]"
                            (click)="search()">
                      <span nz-icon nzType="search"></span>
                    </button>
                  </ng-template>
                  <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>
                </div>

                <div>
                  <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                    Reset All
                  </button>
                </div>

              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </div>

    </div>

    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card mt-5">
      <div class="table-obj">
        <nz-table
          #basicTable
          [nzData]="driverData"
          [nzShowSizeChanger]="pageSize.length > 5"
          [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
          [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
          (nzQueryParams)="onTableParamsChange($event)" [nzScroll]="{ x: 'auto' }" nzTableLayout="fixed"
          nzOuterBordered
        >
          <thead>
          <tr>
            <th style="white-space: nowrap;">Driver Id</th>
            <th style="white-space: nowrap;">Driver Name</th>
            <th style="white-space: nowrap;">Contact Number</th>
            <th style="white-space: nowrap;">Registered/Unregistered</th>
            <th style="white-space: nowrap;">Created Date</th>
            <th *appHasAnyPrivilege="'SUPPLIER_DRIVER_VIEW,DRIVER_VIEW'" style="white-space: nowrap;">Actions</th>
          </tr>
          </thead>
          <tbody>

          <!--        Initial Inventory entry-->
          <tr *ngFor="let data of basicTable.data; let i = index" class="align-baseline">
            <td style="white-space: nowrap;">{{ data.refNo }}</td>
            <td style="white-space: nowrap;">{{ data.fullName }}</td>
            <td class="clickable-mail-phone_no" style="white-space: nowrap;"><a class="clickable-mail-phone_no"
                                                                                href="tel:{{data.mobileNumber}}">{{ data.mobileNumber }}</a>
            </td>
            <td style="white-space: nowrap;">
              <span *ngIf="data.isRegistered">Registered</span>
              <span *ngIf="!data.isRegistered">Un-Registered</span>
            </td>
            <td style="white-space: nowrap;">{{ data.createdAt | date:'yyyy-MM-dd' }}</td>
            <td *appHasAnyPrivilege="'SUPPLIER_DRIVER_VIEW,DRIVER_VIEW'" style="white-space: nowrap;">
              <button *appHasAnyPrivilege="'SUPPLIER_DRIVER_VIEW,DRIVER_VIEW'" class="outline-button mr-3" nz-button
                      nzType="default" (click)="navToSingleDriver(i)">
                View
              </button>
            </td>
          </tr>

          </tbody>
        </nz-table>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
    </div>
  </nz-tab>

  <nz-tab *appHasAnyPrivilege="'SUPPLIER_VEHICLE_VIEW'" nzTitle="Vehicles">
    <nz-card>
      <div class="flex justify-end">
        <button *appHasAnyPrivilege="'SUPPLIER_VEHICLE_CREATE'" class="mb-5" nz-button
                nzType="primary"
                (click)="isVisibleAddVehicleForm()">
          Add Vehicle
        </button>
      </div>
      <div [ngClass]="!loading ? 'block' : 'hidden'" class="rounded-lg">
        <div style="background-color: #FAFAFA" class="hidden lg:grid grid-cols-6 p-4 rounded-t-lg table-obj">
          <div class="flex flex-row justify-between items-center ">
            <p class="font-medium mx-1">Vehicle No</p>
            <nz-divider class="" [nzType]="'vertical'"></nz-divider>
          </div>
          <div class="flex flex-row justify-between items-center ">
            <p class="font-medium mx-1">Vehicle Model</p>
            <nz-divider class="" [nzType]="'vertical'"></nz-divider>
          </div>
          <div class="flex flex-row justify-between items-center ">
            <p class="font-medium mx-1">Registration Number</p>
            <nz-divider class="" [nzType]="'vertical'"></nz-divider>
          </div>
          <div class="flex flex-row justify-between items-center ">
            <p class="font-medium mx-1">Year of Manufacture</p>
            <nz-divider class="" [nzType]="'vertical'"></nz-divider>
          </div>
          <div class="flex flex-row justify-between items-center ">
            <p class="font-medium mx-1">Added Date</p>
            <nz-divider class="" [nzType]="'vertical'"></nz-divider>
          </div>
          <div *appHasAnyPrivilege="'SUPPLIER_VEHICLE_UPDATE,SUPPLIER_VEHICLE_DELETE'"
               class="flex justify-center">
            <p class="font-medium">Actions</p>
          </div>
        </div>

        <div>
          <div *ngFor="let vehi of paginatedVehicles; let i = index" class="flex flex-col py-2 px-4  bg-white">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 p-4 table-obj">
              <div class="">
                <p class="font-medium block lg:hidden">Vehicle No</p>
                <p>VN0{{ i + 1 }}</p>
              </div>
              <div class="">
                <p class="font-medium block lg:hidden">Vehicle Model</p>
                <p>{{ vehi?.vehicleModel }}</p>
              </div>
              <div class="">
                <p class="font-medium block lg:hidden">Registration Number</p>
                <p>{{ vehi?.registerNumber }}</p>
              </div>
              <div class="">
                <p class="font-medium block lg:hidden">Year of Manufacture</p>
                <p>{{ vehi?.yearOfManufacture | date: 'dd-MM-y' }}</p>
              </div>
              <div class="">
                <p class="font-medium block lg:hidden">Added Date</p>
                <p>{{ vehi?.createdAt | date: 'dd-MM-y' }}</p>
              </div>
              <div *appHasAnyPrivilege="'SUPPLIER_VEHICLE_UPDATE,SUPPLIER_VEHICLE_DELETE'"
                   class="flex flex-col lg:justify-end gap-3 lg:gap-0">
                <div class="block lg:hidden">
                  <p class="font-medium">Actions</p>
                </div>
                <div class="flex gap-2">
                  <button *appHasAnyPrivilege="'SUPPLIER_VEHICLE_DELETE'"
                          class="outline-button"
                          nz-button nzType="default" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to remove this vehicle?"
                          (nzOnConfirm)="removeVehicleDetails(i)" (nzOnCancel)="cancel()">Remove
                  </button>
                  <button *appHasAnyPrivilege="'SUPPLIER_VEHICLE_UPDATE'" class="outline-button"
                          nz-button nzType="default"
                          (click)="editVehicle(i)">Edit
                  </button>
                </div>
              </div>
            </div>

            <div class="grid md:grid-cols-4 lg:grid-cols-7 gap-4 content-end">
              <div *ngFor="let image of vehi?.vehicleImages">
                <div>
                  <div class="flex justify-center items-center bg-slate-100">
                    <img class="h-40  w-full" style="cursor: pointer; object-fit: cover;"
                         (click)="showModal(image.attach?.url)" src="{{getImage(image, image?.type)}}" alt="">
                  </div>
                  <div class="flex justify-center mt-2">
                    <span style="color: #a2a2a2" class="text-center">{{ image?.type | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
            <nz-divider class="my-4" [nzType]="'horizontal'"></nz-divider>
          </div>
          <div style="display: flex; justify-content: flex-end;">
            <nz-pagination
              *ngIf="this.vehicles.length >= 1"
              [nzPageIndex]="currentPageIndex"
              [nzTotal]="vehicles.length"
              [nzPageSize]="pageSizeVeh"
              (nzPageIndexChange)="onPageIndexChange($event)"
            ></nz-pagination>
          </div>
        </div>
      </div>
    </nz-card>

    <app-vehicle-details-form [isVisible]="isVisibleAddVehicle" (addVehicleOnChange)="addVehicleOnChange($event)"
                              [supplier]="supplierId"></app-vehicle-details-form>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template
        [typeName]="'driver-single-view-vehicle-tab'"></app-single-view-skeleton-template>
    </div>

  </nz-tab>

  <nz-tab nzTitle="Tour Detail" *appHasAnyPrivilege="'SUPPLIER_TOUR_DETAILS_VIEW'">

    <section class="my-3">

      <nz-card>
        <div class="flex flex-col gap-3">
          <div [ngClass]="loading ? 'hidden' : 'block'">
            <nz-collapse>
              <nz-collapse-panel [nzHeader]="'Advanced Search'">
                <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                  <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton" style="width: auto">
                      <input type="text" (keydown.enter)="searchTour()" [(ngModel)]="searchTextTour" nz-input
                             placeholder="Search here"/>
                    </nz-input-group>

                    <ng-template #suffixIconSearchButton>
                      <button nz-button nzType="primary" nzSearch (click)="searchTour()"
                              class="bg-[#6B6C6E] border-[#6B6C6E]">
                        <span nz-icon nzType="search"></span>
                      </button>
                    </ng-template>
                    <nz-divider
                      class="hidden lg:block"
                      [nzType]="'vertical'"
                    ></nz-divider>

                    <div class="flex w-full lg:w-auto  flex-col lg:flex-row lg:items-center">
                      <nz-form-label class="flex">Filter By Status</nz-form-label>

                      <nz-select
                        [(ngModel)]="statusFilter"
                        (ngModelChange)="searchTour()"
                        nzPlaceHolder="Select Status"
                        [nzAllowClear]="true"
                      >
                        <nz-option nzLabel="Reservation" nzValue="RESERVATION"></nz-option>
                        <nz-option nzLabel="On Transfer" nzValue="ON_TRANSFER"></nz-option>
                        <nz-option nzLabel="On Rent" nzValue="ON_RENT"></nz-option>
                        <nz-option nzLabel="On Other Tour" nzValue="ON_OTHER_TOUR"></nz-option>
                        <nz-option nzLabel="Completed" nzValue="COMPLETED"></nz-option>
                        <nz-option nzLabel="Cancelled" nzValue="CANCELLED"></nz-option>
                      </nz-select>
                      <nz-divider
                        class="hidden lg:block"
                        [nzType]="'vertical'"
                      ></nz-divider>
                    </div>
                    <nz-range-picker [(ngModel)]="dateFilter"
                                     (ngModelChange)="onChangeDateFilter($event)"></nz-range-picker>
                    <!--                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>-->
                    <!--                <div class="flex gap-2">-->
                    <!--                  <button nz-button nzType="default" class="rounded-full">Arrival</button>-->
                    <!--                  <button nz-button nzType="default" class="rounded-full">Departure</button>-->
                    <!--                </div>-->
                  </div>
                  <div>
                    <button nz-button nzBlock class="outline-button" (click)="resetSearchTour()">
                      Reset All
                    </button>
                  </div>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </div>

          <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card mt-4">
            <div class="table-obj">
              <nz-table
                #basicTable [nzData]="bookingData" [nzShowSizeChanger]="pageSize.length > 5"
                [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                (nzQueryParams)="onTableParamsChangeTour($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }"
                nzOuterBordered class="table-wSpace-nowrap"
              >
                <thead>
                <tr>
                  <th>Booking ID</th>
                  <th>Booking Type</th>
                  <th>Driver Name</th>
                  <th>Booking Start Date and Time</th>
                  <th>Booking End Date and Time</th>
                  <th>Booking Status</th>
                  <th>Vehicle Reg Number</th>
                  <th>Agent</th>
                  <th>Customer Name</th>
                </tr>

                </thead>
                <tbody>

                <ng-container
                  *ngFor="let data of basicTable.data"
                  class="align-baseline"
                >

                  <tr>
                    <td>
                      <span (click)="navigate(data)" class="clickable-text"
                            *ngIf="data.bookingType === 'transfer'">{{ data.transferId }}</span>
                      <span (click)="navigate(data)" class="clickable-text"
                            *ngIf="data.bookingType === 'rent'">{{ data.refNo }}</span>
                      <span (click)="navigate(data)" class="clickable-text"
                            *ngIf="data.bookingType === 'other'">{{ data.otherBookingId }}</span>
                    </td>

                    <td *ngIf="data.bookingType === 'rent'">Rent</td>
                    <td *ngIf="data.bookingType === 'transfer'">Transfer</td>
                    <td *ngIf="data.bookingType === 'other'">Other</td>

                    <td
                      *ngIf="data.bookingType === 'rent'">{{ data.allocationDetails?.allocatedDriver ? data.allocationDetails.allocatedDriver?.fullName : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && supplierId === data.arrivalDetails?.allocateDriver?.supplier">{{ data.arrivalDetails?.allocateDriver?.fullName }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && supplierId === data.departureDetails?.allocateDriver?.supplier && supplierId !== data.arrivalDetails?.allocateDriver?.supplier">{{ data.departureDetails?.allocateDriver?.fullName }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && supplierId !== data.departureDetails?.allocateDriver?.supplier && supplierId !== data.arrivalDetails?.allocateDriver?.supplier">
                      -
                    </td>
                    <td
                      *ngIf="data.bookingType === 'other'">{{ data.allocationDetails?.allocatedDriver ? data.allocationDetails.allocatedDriver?.fullName : '-' }}
                    </td>

                    <td
                      *ngIf="data.bookingType === 'rent'">{{ data.tourDetails.departureInformation ? (data.tourDetails.departureInformation.departureDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureInformation.departureDate | date:'hh:mm a') : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Arrival' ">{{ data.tourDetails ? (data.tourDetails.arrivalFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.pickUpTime | date:'hh:mm a') : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Departure'">{{ data.tourDetails.departureTourDetails.departureFlightDate ? (data.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departurePickUpTime | date:'hh:mm a') : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'other'">{{ data.reservationDetails.arrivalDate ? (data.reservationDetails.arrivalDate | date:'yyyy-MM-dd') + ' | ' + (data.reservationDetails.arrivalTime | date:'hh:mm a') : '-' }}
                    </td>


                    <td
                      *ngIf="data.bookingType === 'rent'">{{ data.tourDetails.arrivalInformation ? (data.tourDetails.arrivalInformation.arrivalDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.arrivalInformation.arrivalTime | date:'hh:mm a') : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Departure'">{{ data.tourDetails.departureTourDetails.departureEndDate ? (data.tourDetails.departureTourDetails.departureEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departureEndTime | date:'hh:mm a') : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Arrival' ">{{ data.tourDetails ? (data.tourDetails.arrivalEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.arrivalEndTime | date:'hh:mm a') : '-' }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'other'">{{ data.reservationDetails.departureDate ? (data.reservationDetails.departureDate | date:'yyyy-MM-dd') + ' | ' + (data.reservationDetails.departureTime | date:'hh:mm a') : '-' }}
                    </td>
                    <td>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'COMPLETED') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'COMPLETED' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'COMPLETED' && data.bookingDetails.bookingCategory === 'Departure')" [nzColor]="'#3ab200'"
                              class="rounded-full"
                      >Completed
                      </nz-tag
                      >
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'CANCELLED') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'CANCELLED' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'CANCELLED' && data.bookingDetails.bookingCategory === 'Departure')" class="rounded-full" [nzColor]="'#F3454C'"
                      >Cancelled
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'RESERVATION') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'RESERVATION' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'RESERVATION' && data.bookingDetails.bookingCategory === 'Departure')"
                        [nzColor]="'#FF8C00'" class="rounded-full"
                      >Reservation
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_RENT') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_RENT' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_RENT' && data.bookingDetails.bookingCategory === 'Departure')"
                        [nzColor]="'#4655f5'" class="rounded-full"
                      >On Rent
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_TRANSFER') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_TRANSFER' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_TRANSFER' && data.bookingDetails.bookingCategory === 'Departure')"
                        [nzColor]="'#4655f5'" class="rounded-full"
                      >On Transfer
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_OTHER_TOUR') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_OTHER_TOUR' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_OTHER_TOUR' && data.bookingDetails.bookingCategory === 'Departure')"
                        [nzColor]="'#4655f5'" class="rounded-full"
                      >On Other Tour
                      </nz-tag>
                    </td>

                    <td
                      *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateVehicle">{{ displayVehicle(data.departureDetails.allocateVehicle) }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'transfer' && data.arrivalDetails.allocateVehicle">{{ displayVehicle(data.arrivalDetails.allocateVehicle) }}
                    </td>
                    <td
                      *ngIf="(data.bookingType === 'transfer' && !data.departureDetails?.allocateVehicle) && (data.bookingType === 'transfer' && !data.arrivalDetails?.allocateVehicle)">{{ displayVehicle(data.departureDetails?.allocateVehicle) }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'rent'">{{ displayVehicle(data.allocationDetails.allocatedDriverVehicle) }}
                    </td>
                    <td
                      *ngIf="data.bookingType === 'other' ">{{ displayVehicle(data.allocationDetails.allocatedDriverVehicle) }}
                    </td>


                    <td *ngIf="data.bookingType === 'transfer'"
                        (click)="nav(data.bookingDetails.agent._id, 'agent')">{{ data.bookingDetails.agent ? data.bookingDetails.agent?.name : '-' }}
                    </td>
                    <td *ngIf="data.bookingType === 'rent'"
                        (click)="nav(data.bookingDetails.agent._id, 'agent')">{{ data.bookingDetails.agent ? data.bookingDetails.agent?.name : '-' }}
                    </td>
                    <td *ngIf="data.bookingType === 'other'">-</td>

                    <td *ngIf="data.bookingType === 'transfer'"
                        (click)="nav(data.tourDetails.customer._id, 'customer')">{{ data.tourDetails.customer ? data.tourDetails.customer.renterDetails.fullName : '-' }}
                    </td>
                    <td *ngIf="data.bookingType === 'rent'"
                        (click)="nav(data.customerDetails.customer._id, 'customer')">{{ data.customerDetails.customer ? data.customerDetails?.customer?.renterDetails?.fullName : '-' }}
                    </td>
                    <td *ngIf="data.bookingType === 'other'">-</td>
                  </tr>
                  <ng-container
                    *ngIf="data.bookingType === 'transfer' && (data.bookingDetails.bookingCategory === 'Arrival' && data.tourDetails.departureCheck)">

                    <tr>
                      <td>
                        <span (click)="navigate(data)" class="clickable-text"
                              *ngIf="data.bookingType === 'transfer'">{{ data.transferId }}</span>
                      </td>

                      <td *ngIf="data.bookingType === 'transfer'">Transfer</td>

                      <td
                        *ngIf="data.bookingType === 'transfer' && supplierId === data.departureDetails?.allocateDriver?.supplier">{{ data.departureDetails?.allocateDriver ? data.departureDetails?.allocateDriver?.fullName : '-'}}
                      </td>
                      <td
                        *ngIf="data.bookingType === 'transfer' && supplierId !== data.departureDetails?.allocateDriver?.supplier">
                        -
                      </td>

                      <td
                        *ngIf="data.bookingType === 'transfer'">{{ data.tourDetails.departureTourDetails.departureFlightDate ? (data.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departurePickUpTime | date:'hh:mm a') : '-' }}
                      </td>


                      <td
                        *ngIf="data.bookingType === 'transfer'">{{ data.tourDetails.departureTourDetails.departureEndDate ? (data.tourDetails.departureTourDetails.departureEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departureEndTime | date:'hh:mm a') : '-' }}
                      </td>

                      <td>
                        <nz-tag *ngIf="data?.departureDetails.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                                class="rounded-full"
                        >Completed
                        </nz-tag
                        >
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'CANCELLED'" class="rounded-full" [nzColor]="'#F3454C'"
                        >Cancelled
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'RESERVATION'"
                          [nzColor]="'#FF8C00'" class="rounded-full"
                        >Reservation
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'ON_RENT'"
                          [nzColor]="'#4655f5'" class="rounded-full"
                        >On Rent
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'ON_TRANSFER' "
                          [nzColor]="'#4655f5'" class="rounded-full"
                        >On Transfer
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'ON_OTHER_TOUR' "
                          [nzColor]="'#4655f5'" class="rounded-full"
                        >On Other Tour
                        </nz-tag>
                      </td>

                      <td
                        *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateVehicle">{{ displayVehicle(data.departureDetails.allocateVehicle) }}
                      </td>
                      <td
                        *ngIf="(data.bookingType === 'transfer' && !data.departureDetails?.allocateVehicle) && (data.bookingType === 'transfer' && !data.arrivalDetails?.allocateVehicle)">{{ displayVehicle(data.departureDetails?.allocateVehicle) }}
                      </td>


                      <td *ngIf="data.bookingType === 'transfer'"
                          (click)="nav(data.bookingDetails.agent._id, 'agent')">{{ data.bookingDetails.agent ? data.bookingDetails.agent?.name : '-' }}
                      </td>


                      <td *ngIf="data.bookingType === 'transfer'"
                          (click)="nav(data.tourDetails.customer._id, 'customer')">{{ data.tourDetails.customer ? data.tourDetails.customer.renterDetails.fullName : '-' }}
                      </td>

                    </tr>

                  </ng-container>

                </ng-container>
                </tbody>
              </nz-table>
            </div>
          </div>
          <div [ngClass]="loading ? 'block' : 'hidden'">
            <app-table-skeleton-template [columnData]="skeletonTableColumnsTour"></app-table-skeleton-template>
          </div>


        </div>
      </nz-card>
    </section>


  </nz-tab>

  <nz-tab *appHasAnyPrivilege="'SUPPLIER_NOTES_VIEW'" nzTitle="Notes">

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <section id="notes" class="mt-5">
        <nz-card>
          <div>
            <h5 class="text-primary">Notes</h5>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
              <textarea class="mt-2" rows="8" nz-input id="disabledTextarea" disabled [(ngModel)]="note"></textarea>
            </div>
          </div>
        </nz-card>
      </section>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'note-view'"></app-single-view-skeleton-template>
    </div>
  </nz-tab>
</nz-tabset>


<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWrapClassName]="'lightbox-modal'"
>
  <ng-template #modalTitle></ng-template>

  <ng-template #modalContent>
    <div class="">
      <img [src]="selectedImage" class="h-[70vh] max-h-[70vh] w-[90vw] xl:w-[50vw] xl:h-full object-contain"
           alt="image">
    </div>
  </ng-template>

  <ng-template #modalFooter>

  </ng-template>
</nz-modal>
